module.exports = __webpack_public_path__ + "img/Carousel-funcionalidades-icono-01.3cdb5774.svg";